import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import Logger from 'redux-logger';
import Reducer from './Store/Reducer';
const Store =
	process.env.NODE_ENV === 'development'
		? createStore(Reducer, composeWithDevTools(applyMiddleware(Logger)))
		: createStore(Reducer);
export default Store;
